import C from '@/utils/rule/constant'
import BaseCalculator from "./BaseCalculator"

class MST extends BaseCalculator {

    /**
     * 胸腰差比
     * @type {number}
     */
    ratio_xy = 0
    /**
     * 胸臀差
     * @type {number}
     */
    ratio_xt = 0

    body = {
        [C.B_TTT_HT] : {
            '瘦臀' : 0,
            '正常' : 0,
            '丰臀' : 0,
            '饱满' : 0,
        },
        [C.B_ZTT_H] : {
            '翘臀' : 0,
            '正常' : 0,
            '坠臀' : 0,
            '宽跨' : 0,
        }
    }

    /**
     * 成衣参数key和计算公式
     * @type {{[p: string]: function(*, *, *): *}}
     * 匹配正则 ((base)|(net)|(plus))\[C\.(C|N)([A-Z_])*\]
     */
    complete_size = {
        [C.PREFERENCE_FITTED] : {
            [C.C_KYW_WL] : function (net, base, plus) {
                return parseFloat(net[C.N_KYW_TWL])
            },
            [C.C_KTW_AL] : function (net, base, plus) {
                return parseFloat(net[C.N_KTW_HL]) + 6
            },
            [C.C_KQD_FC] : function (net, base, plus) {
                return 0
            },
            [C.C_KDTW_LL] : function (net, base, plus) {
                return parseFloat(net[C.N_DTW_LL]) + 8
            },
            [C.C_KKC_TL] : function (net, base, plus) {
                return parseFloat(net[C.N_KC_TL])
            },
            [C.C_KJK_F] : function (net, base, plus) {
                return parseFloat(net[C.N_XTDW_CL])
            },
        },
        [C.PREFERENCE_NORMAL] : {
            [C.C_KYW_WL] : function (net, base, plus) {
                return parseFloat(net[C.N_KYW_TWL])
            },
            [C.C_KTW_AL] : function (net, base, plus) {
                return parseFloat(net[C.N_KTW_HL]) + 6
            },
            [C.C_KQD_FC] : function (net, base, plus) {
                return 0
            },
            [C.C_KDTW_LL] : function (net, base, plus) {
                return parseFloat(net[C.N_DTW_LL]) + 8
            },
            [C.C_KKC_TL] : function (net, base, plus) {
                return parseFloat(net[C.N_KC_TL])
            },
            [C.C_KJK_F] : function (net, base, plus) {
                return parseFloat(net[C.N_XTDW_CL])
            },
        },
        [C.PREFERENCE_LOOSE] : {
            [C.C_KYW_WL] : function (net, base, plus) {
                return parseFloat(net[C.N_KYW_TWL])
            },
            [C.C_KTW_AL] : function (net, base, plus) {
                return parseFloat(net[C.N_KTW_HL]) + 8
            },
            [C.C_KQD_FC] : function (net, base, plus) {
                return 0
            },
            [C.C_KDTW_LL] : function (net, base, plus) {
                return parseFloat(net[C.N_DTW_LL]) + 10
            },
            [C.C_KKC_TL] : function (net, base, plus) {
                return parseFloat(net[C.N_KC_TL])
            },
            [C.C_KJK_F] : function (net, base, plus) {
                return parseFloat(net[C.N_XTDW_CL])
            },
        }
    }

    /**
     * 覆盖父类方法
     * @param size
     */
    setNetSize(size) {
        super.setNetSize(size)
        // 计算胸腰差比
        this.ratio_xy = (parseFloat(this.net_size[C.N_ZYW_MWL]) / this.net_size[C.N_XW_CL] - 1) * 100
        this.ratio_xt = this.net_size[C.N_XW_CL] - parseFloat(this.net_size[C.N_TW_HL])
    }

    /**
     * 穿衣偏好的加放基础值
     * @param somatotype
     * @param preference
     * @returns {*}
     */
    base(somatotype, preference) {
        let data =  {
        }

        return {}
    }

    /**
     * 加放量值
     * @param somatotype
     * @param preference
     * @returns {*}
     */
    plus(somatotype, preference) {
        let data =  {
        }

        return {}
    }


    /**
     * 计算成衣尺寸
     * @param preference
     * @returns {{}}
     */
    getCompleteSize(preference) {
        this.preference = preference
        let formulas = this.complete_size[this.preference];

        let result = {}
        for(let key in formulas) {
            let temp = Math.round(formulas[key].apply(this, [this.net_size]) * 10) / 10
            result[key] = isNaN(temp) ? 0 : temp
        }

        return result
    }

    getBodySize() {
        let result = {}
        for(let key in this.body_size) {
            if (key in this.body) result[key] = this.body[key][this.body_size[key]] || 0

        }

        return result
    }
}

export default MST
